import { gql } from "@grandvisionhq/graphql";
const getReturnFailuresFragment = gql`
  fragment GetReturnFailuresFragment on QueryReturnFailure {
    ... on Failure {
      message
    }
  }
`;
export {
  getReturnFailuresFragment
};
//# sourceMappingURL=get-return-failures.js.map
